let _data = {};

export const localStorage = window.localStorage || {
  getItem: (field) => {
    return _data[field];
  },
  setItem: (field, content) => {
    return (_data[field] = content);
  },
  removeItem: (field) => {
    return delete _data[field];
  },
  clear: () => {
    return (_data = {});
  },
};
